// @flow
import React, { Fragment } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { resizeImage } from 'lib/common';
import { FaRegHeart } from 'react-icons/fa';
import { AiOutlineShopping, AiOutlineMail, AiOutlineWallet } from 'react-icons/ai';
import './UserMobileMenu.scss';
import UserMobileMenuLink from '../UserMobileMenuLink';
import UserMenuItem from '../UserMenuItem';

type Props = {
  onClickOutside(): void,
  onLogout(): Promise<*>,
  displayName: string,
  username: string,
  rule: string,
  logged: boolean,
  showMobileUserMenu: boolean,
  thumbnail: ?string,
  hasDepositHistory: boolean,
};

const UserMobileMenu = ({
  onClickOutside,
  onLogout,
  displayName,
  username,
  rule,
  logged,
  showMobileUserMenu,
  thumbnail,
  hasDepositHistory,
  location,
}: Props) => {
  const imgUrl = resizeImage(thumbnail, 36, 36);
  const thumbnailImage = thumbnail ? imgUrl : 'https://images.cacheby.com/default_thumbnail.png';
  return (
    <Fragment>
      <div
        className={cx('overlay', { 'overlay--appear': showMobileUserMenu })}
        onClick={onClickOutside}
      />
      {logged ? (
        <aside className={cx('drawer', { 'drawer--appear': showMobileUserMenu })}>
          <div className="drawer__section drawer__section-after-login">
            <div className="drawer__profile">
              <Link to={`/@${username}`} onClick={onClickOutside} className="profile__thumbnail">
                <img src={thumbnailImage} alt={`${displayName}님의 프로필 사진`} />
              </Link>
              <div className="profile__detail">
                <p className="profile__detail-text">{displayName}</p>
                <Link to="/settings" className="profile__detail-link" onClick={onClickOutside}>
                  회원정보수정
                </Link>
              </div>
            </div>
          </div>
          <ul className="drawer__section drawer__section-after-login">
            <li className="drawer__item">
              <AiOutlineShopping size={22} />
              <UserMobileMenuLink to="/orders" onClickOutside={onClickOutside}>
                주문 목록
              </UserMobileMenuLink>
            </li>
            <li className="drawer__item">
              <FaRegHeart size={22} />
              <UserMobileMenuLink to={`/wish`} onClickOutside={onClickOutside}>
                찜 목록
              </UserMobileMenuLink>
            </li>
            {hasDepositHistory && (
              <li className="drawer__item">
                <AiOutlineWallet size={22} />
                <UserMobileMenuLink to="/deposit" onClickOutside={onClickOutside}>
                  예치금
                </UserMobileMenuLink>
              </li>
            )}
            {/* <li className="drawer__item">
              <AiOutlineMail size={22} />
              <UserMobileMenuLink to="/estimate" onClickOutside={onClickOutside}>
                견적 목록
              </UserMobileMenuLink>
            </li> */}
          </ul>
          <ul className="drawer__section drawer__section-after-login">
            <li className="drawer__item">
              <a
                href="https://forms.gle/Rj8L977m1ze3yjev8"
                target="_blank"
                rel="noopener noreferrer"
              >
                파트너 입점신청
              </a>
            </li>
            <li className="drawer__item">
              <span onClick={onLogout}>로그아웃</span>
            </li>
          </ul>
        </aside>
      ) : (
        <aside className={cx('drawer', { 'drawer--appear': showMobileUserMenu })}>
          <ul className="drawer__section drawer__section-before-login">
            <li className="drawer__logo">
              <div>
                <Link to="/">
                  <img
                    className="logo-img"
                    src="https://images.cacheby.com/logo.svg"
                    alt="CacheBy"
                  />
                </Link>
              </div>
            </li>
            <li className="drawer__item">
              <Link
                to={`/login?next=${location.pathname}`}
                className="item-button"
                onClick={onClickOutside}
              >
                로그인
              </Link>
            </li>
            <li className="drawer__item">
              <Link
                to="/register"
                className="item-button item-button-outline"
                onClick={onClickOutside}
              >
                회원가입
              </Link>
            </li>
          </ul>
          <div className="drawer__section">
            <li className="drawer__item">
              <a
                className="item-link"
                href="https://forms.gle/Rj8L977m1ze3yjev8"
                target="_blank"
                rel="noopener noreferrer"
              >
                파트너 입점신청
              </a>
            </li>
          </div>
        </aside>
      )}
    </Fragment>
  );
};
export default UserMobileMenu;



// WEBPACK FOOTER //
// ./src/components/base/UserMobileMenu/UserMobileMenu.js